import React, { useState } from 'react';

import { Icon, RotateIcon } from '@rbilabs/components-library';
import styled, { keyframes } from 'styled-components';

interface ITextExpanderProps {
  openText?: string;
  closedText?: string;
  defaultExpanded?: boolean;
}

const Wrapper = styled.div``;

const Heading = styled.p`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const fadeIn = keyframes`
from {
    opacity: 0
}
to {
    opacity: 1
}
`;

const ArrowContainer = styled.div`
  margin-left: 0.75rem;
  user-select: none;
`;

const Body = styled.div`
  animation: ${fadeIn} 0.2s forwards;
`;

const TextExpander: React.FC<ITextExpanderProps> = ({
  openText,
  closedText,
  children,
  defaultExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => setIsExpanded(isCurrentlyExpanded => !isCurrentlyExpanded);

  return (
    <Wrapper>
      <Heading onClick={toggleExpanded}>
        {isExpanded ? openText : closedText}
        <ArrowContainer>
          <RotateIcon active={isExpanded} toDeg={90}>
            <Icon icon="next" color="icon-default" width="16px" aria-hidden />
          </RotateIcon>
        </ArrowContainer>
      </Heading>
      {isExpanded && <Body>{children}</Body>}
    </Wrapper>
  );
};

export default TextExpander;
